import { URLs } from './constants/constants';

export function zip(a, b) {
  return a.map((x, i) => [x, b[i]]);
}

export function formatNumber(num, units, decimals, returnString) {
  if (!units || units < 1) {
    units = 1;
  }
  num /= units;
  if (!decimals && decimals !== 0) {
    decimals = 2;
  }
  if (returnString) {
    return num
      .toFixed(decimals)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }
  const exponent = Math.pow(10, decimals);
  return Math.round((num + Number.EPSILON) * exponent) / exponent;
}

export function deepClone(obj) {
  // https://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-deep-clone-an-object-in-javascript

  let temp; // or new Date(obj);
  if (obj === null || typeof obj !== 'object' || 'isActiveClone' in obj) return obj;

  if (obj instanceof Date) {
    temp = new obj.constructor();
  } else {
    temp = obj.constructor();
  }

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      obj.isActiveClone = null;
      temp[key] = deepClone(obj[key]);
      delete obj.isActiveClone;
    }
  }
  return temp;
}

export function hashCode(obj) {
  const s = JSON.stringify(obj);
  let hash = 0;
  if (obj) {
    for (let i = 0; i < s.length; i++) {
      const character = s.charCodeAt(i);
      hash = (hash << 5) - hash + character;
      hash &= hash; // Convert to 32bit integer
    }
  }
  return hash;
}

export function isEmptyObject(obj) {
  for (const prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }
  return true;
}

export function scrollIntoView(id) {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}

export function extractErrorMessage(error) {
  let message;

  if (error.message) {
    message = error.message;
  }

  if (
    message === 'Request failed with status code 500' &&
    error.response &&
    error.response.data &&
    error.response.data.message
  ) {
    message = error.response.data.message;
  } else if (!message) {
    message = JSON.stringify(error, Object.getOwnPropertyNames(error));
  }

  return message;
}

/**
 * Checks if two arrays are equivalent.
 * The order of items are ignored.
 */
export function arraysEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  const sorteda = a.concat().sort();
  const sortedb = b.concat().sort();

  for (let i = 0; i < a.length; ++i) {
    if (sorteda[i] !== sortedb[i]) return false;
  }
  return true;
}

export const toDownloadFormat = (columnDefinitions, items, delimiter = '\t') => {
  const header = columnDefinitions.map((def) => def.header).join(delimiter);
  const columnIds = columnDefinitions.map((def) => def.id);
  const rows = items
    .map((item) => {
      return columnIds.map((id) => `"${item[id] == null ? '' : item[id]}"`).join(delimiter);
    })
    .join('\n');

  return `${header}\n${rows}`;
};

export const downloadFile = (data, fileName) => {
	if (typeof window.navigator.msSaveBlob !== 'undefined') { // Edge
		const blob = new Blob([data], { type: 'application/xls' });
		window.navigator.msSaveOrOpenBlob(blob, fileName);
	} else { // Chrome
	  const element = document.createElement('a');
	  element.setAttribute('href', `data:text/tsv;charset=utf-8,${encodeURIComponent(data)}`);
	  element.setAttribute('download', fileName);

	  element.style.display = 'none';
    document.body.appendChild(element);
    
    if (window.Cypress) {
      console.log("Running Cypress tests - will not perform actual download of file.");      
      return;
    }

	  element.click();

	  document.body.removeChild(element);
  }
};

export const toTitleCase = (str) => {
  return str.replace(/\w\S*/g, function(txt){
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export function getCurrentStage() {
  const stage = Object.keys(URLs).find(stage => window.location.href.indexOf(URLs[stage]) !== -1);
  return stage ? stage.replace('_','') : 'test';
}

export const marketplacesById = (marketplaceConfig) => {
  return marketplaceConfig.reduce((map, obj) => {
    map[obj.id] = obj.detail;
    return map;
    }, {});
}

export const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};


// WEBPACK FOOTER //
// ./src/utilities.js